export class EksNamespaceRestoreResult {
    'volumes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<EksVolumeRestoreResult>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksNamespaceRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
